<div>
	<div>
		@for (row of items; track row.id) {
			<div class="d-flex gap-2 align-items-end">
				@for (field of fields; track field; let first = $first) {
					<div class="testscale-tbl-field">
						<label>{{ field | langVal }}</label>
						<app-gen-input
							[className]="'input-' + row.id + '-' + field"
							[actualObj]="row"
							[fieldName]="field"
							(changeEvent)="handleUpdate(row, field, row[field])"
							[isNumber]="!first"
						/>
					</div>
				}
				<div>
					<button
						class="btn btn-icon"
						tabindex="-1"
						(click)="handleDelete(row.id)"
						icon="delete"
					></button>
				</div>
			</div>
		}
		<div>
			<div
				colspan="99"
				style="padding-block: 10px"
			>
				<button
					class="btn btn-primary"
					(click)="handleAddRow()"
					tabClick
				>
					{{ "add_values" | langVal }}
				</button>
			</div>
		</div>
	</div>
</div>
